module.exports = __webpack_public_path__ + "banner111.png?2c9f4057eb41d9b5271e20783f7d93de";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner111.png
// module id = 688
// module chunks = 0